module.exports = "//static.hsappstatic.net/LoginUI/static-1.15557/img/openai-logo-white.svg"